export const packageList = [
  {
    name: 'coo_allocation',
    activeRule: ['coo-allocation'],
  },
  {
    name: 'coo_dispatch',
    activeRule: ['coo-dispatch'],
  },
  {
    name: 'coo_mix',
    activeRule: ['coo-mix'],
  },
  {
    name: 'coo_operation',
    activeRule: ['coo-operation'],
  },
  {
    name: 'coo_kts_remote',
    activeRule: [],
  },
  {
    name: 'coo_flow_remote',
    activeRule: [],
  },
  {
    name: 'coo_common',
    activeRule: [],
  },
  {
    name: 'coo_basic',
    activeRule: ['coo-basic'],
  },
  {
    name: 'coo',
    activeRule: ['coo'],
  },
]

export const remoteModuleConfig = {
  dev: ['coo', 'coo_allocation', 'coo_dispatch', 'coo_mix', 'coo_operation', 'coo_kts_remote', 'coo_flow_remote', 'coo_common', 'coo_basic'],
  stg: ['coo', 'coo_allocation', 'coo_dispatch', 'coo_mix', 'coo_operation', 'coo_kts_remote', 'coo_flow_remote', 'coo_common', 'coo_basic'],
  uat: ['coo', 'coo_allocation', 'coo_dispatch', 'coo_mix', 'coo_operation', 'coo_kts_remote', 'coo_flow_remote', 'coo_common', 'coo_basic'],
  prd: ['coo', 'coo_common', 'coo_mix', 'coo_allocation', 'coo_dispatch', 'coo_operation', 'coo_kts_remote', 'coo_flow_remote', 'coo_basic'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/coo/index.js